import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDefaultUrl } from "../../../redux/slices/multiUrl";
import { handleLink } from "../../../hooks/helpers";
import InputText from "../../../components/input/inputText";
import { Form } from "react-bootstrap";
import { MAX_LINK_LENGTH } from "../../../constants/inputValues";

export default function DefaultUrlField({ validLink, setValidLink, error }) {
  const { defaultUrl, lang, errorMsg } = useSelector((state) => ({
    defaultUrl: state.multiUrl.defaultUrl,
    lang: state.changeLang.language.stepTwo,
    errorMsg: state.changeLang.language.stepTwo.errors,
  }));
  const dispatch = useDispatch();

  return (
    <>
      <InputText
        valid={
          validLink &&
          defaultUrl?.length > 3 &&
          defaultUrl.length <= MAX_LINK_LENGTH
        }
        error={
          (!validLink && defaultUrl?.length > 3) ||
          (error && !defaultUrl.length && !validLink) ||
          defaultUrl.length > MAX_LINK_LENGTH
        }
        type="link"
        name="link"
        value={defaultUrl}
        onChange={(e) =>
          handleLink(e.target.value, setValidLink, (link) =>
            dispatch(setDefaultUrl(link))
          )
        }
        placeholder={lang.multiUrl[3]}
        popoverText={lang.multiUrl[31]}
      >
        {validLink === false &&
          defaultUrl.length > 3 &&
          defaultUrl.length <= 255 && (
            <Form.Text className="text-danger">
              {lang.link[2]}: https://me-qr.com/
            </Form.Text>
          )}
        {error && !defaultUrl.length && !validLink && (
          <Form.Text className="text-danger">{lang.linkEmpty}</Form.Text>
        )}
        {!validLink && defaultUrl.length > 0 && defaultUrl.length < 4 && (
          <Form.Text className="text-danger">{lang.link[22]}</Form.Text>
        )}
        {/* {!validLink && defaultUrl.length > 255 && (
          <Form.Text className="text-danger">{lang.linkList[25]}</Form.Text>
        )} */}
        {defaultUrl.length > MAX_LINK_LENGTH && (
          <Form.Text className="text-danger">{errorMsg[0]}</Form.Text>
        )}
      </InputText>
    </>
  );
}
